import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useApi } from '../useApi';
import { toast } from '../../../components/Toast';
import { toastExistingCompletedCheck } from '../../../components/Toast/toastExistingCompletedCheck';
import { projectsKeys } from '../projects/projects.key';

type Props = {
  orgNumber: string;
  name: string;
  projectId: string;
};

type CreateCompanyResponse = {
  existingCompletedCheckCreatedAt?: string | null;
};

export function createCompany() {
  const getApi = useApi();
  const queryClient = useQueryClient();

  const createCompany = async (props: Props) => {
    const api = await getApi();

    const res = await api.companiesCreate({
      registrationNumber: props.orgNumber,
      name: props.name,
      projectId: props.projectId,
    });

    return res.data as CreateCompanyResponse;
  };

  const onSuccess = (data: CreateCompanyResponse) => {
    toast.success('Order har lagts');
    queryClient.invalidateQueries({ queryKey: projectsKeys.all });
    toastExistingCompletedCheck(data?.existingCompletedCheckCreatedAt);
  };

  const onError = () => {
    toast.error('Något gick fel');
  };

  const mutation = useMutation(createCompany, {
    onSuccess,
    onError,
  });

  return mutation;
}
